<template>
  <div class="pos-final-ticket-container">
    <div class="pos-final-ticket-wrapper">
      <!-- <header>CHOOSE TICKET PICKUP OPTION</header> -->
      <header>PICKUP TICKET</header>

      <button
        v-on:click="callClose()"
        class="btn-modal-close"
        style="top: -12px; right: 15px"
      >
        &times;
      </button>

      <threecopy-template :ticketDetails="TemplateList"></threecopy-template>

      <onecopy-template :ticketDetails="TemplateList"></onecopy-template>

      <default-template></default-template>

      <arabic-template :ticketDetails="TemplateList"></arabic-template>

      <!-- <default-template :ticketDetails="TemplateList"></default-template> -->

      <!-- <div class="d-none" ref="print_new_ticket" id="IRAQ_PRINT_TICKET"></div> -->

      <!-- (itemIndex+1) % 2 === 0  ?  -->

      <div class="pos-final-ticket-new">
        <div class="row">
          <div
            class="col-3 border-right-dashed border-dark align-items-center text-center pos-ticket-cutter"
          >
            <h5 class="font-weight-bold mb-3">
              Ticket No: {{ bookingDetails.sb_booking_code }}
            </h5>
            <img src="@/assets/img/icons/movie-rolling.svg" class="img-fluid" />
          </div>
          <div class="col-5 pl-5">
            <h5 class="font-weight-bold">
              {{ bookingDetails.movie_title }} ({{ bookingDetails.rating }}) -
              {{ bookingDetails.cine_location }}
            </h5>
            <div class="text-blue lh-1 mb-2">
              <span
                v-if="bookingDetails.version_name"
                class="font-weight-bold mr-2"
                >{{ bookingDetails.version_name }}
              </span>
              <span v-else class="font-weight-bold mr-2"
                >{{ bookingDetails.lang_name }}
              </span>
              <b-badge variant="primary">{{ bookingDetails.mf_name }}</b-badge>
            </div>
            <ul class="list-inline" style="font-weight: 500">
              <li class="list-inline-item">
                {{ bookingDetails.og_show_date | getDay }}
              </li>
              <li class="list-inline-item">|</li>
              <li class="list-inline-item">
                {{ bookingDetails.og_show_date | getMonth }}&nbsp;
                {{ bookingDetails.og_show_date | getDayDigit }}
              </li>

              <li class="list-inline-item">|</li>
              <li class="list-inline-item">
                {{ bookingDetails.og_show_time }}
              </li>
              <!-- <li>{{ bookingDetails.show_date }}</li> -->
            </ul>
            <div>
              <h6 class="text-blue font-weight-bold mb-1">
                {{ bookingDetails.screen_name }}
              </h6>

              <div class="d-flex">
                <img
                  src="@/assets/img/icons/armchair.svg"
                  height="20"
                  width="20"
                  alt
                />
                &nbsp;:
                <ul class="list-inline mb-0 seat-seperated-list ml-2">
                  <li class="list-inline-item">
                    {{
                      bookingDetails.seats_types &&
                      bookingDetails.seats_types.length > 0
                        ? Array.from(
                            new Set(
                              bookingDetails.seats_types.map((x) => x.seatType)
                            )
                          ).join(",")
                        : ""
                    }}
                  </li>
                  <!-- v-for="(bookingSeats, bookingKey) in bookingDetails.seats" -->
                  <!-- :key="bookingKey" -->
                  -
                  <li class="list-inline-item">{{ bookingDetails.seats }}</li>
                </ul>
              </div>
            </div>
            <div v-if="SeatGroupType != ''" class="mt-2">
              <h6 class="text-blue font-weight-bold mb-1">Ticket Type</h6>

              <div class="d-flex">
                <ul class="list-inline mb-0 seat-seperated-list ml-2">
                  <li class="list-inline-item">
                    {{ SeatGroupType }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <!-- <div class="col-4 pr-5 text-right">
            <h6 class="font-weight-bold mb-0"></h6>
          </div>-->
          <div class="col-4 align-self-end pr-4 text-right">
            <h6 class="mb-1">
              <p
                class="mb-0"
                v-for="(charges, chargesIndex) in AdditionalCharges"
                :key="chargesIndex"
              >
                {{ charges.ct_name }} :
                {{
                  charges.pas_is_rebate && charges.pas_is_rebate === "Y"
                    ? -currFormat(
                        charges.sp_value +
                          rateCardAddonsChargeTypeToAdd(charges.charge_type_id)
                      )
                    : currFormat(
                        charges.sp_value +
                          rateCardAddonsChargeTypeToAdd(charges.charge_type_id)
                      )
                }}
                {{ currencyData.curr_code }}
              </p>
            </h6>

            <h6 class="" v-if="RateCardAddonsChargesFinalAmount">
              Addons Charges: {{ currFormat(RateCardAddonsChargesFinalAmount) }}
            </h6>
            <h6 class="font-weight-bold mb-0">
              Ticket Amount : {{ currFormat(totalAmount) }}
              {{ currencyData.curr_code }}
              <br />
              Loyalty Amount : {{ currFormat(getloyaltyAmount) }}
              {{ currencyData.curr_code }}
              <br />
              Offer Amount : {{ currFormat(offerPrice) }}
              {{ currencyData.curr_code }}
              <br />
              <span v-if="CashCardAmount && CashCardAmount > 0">
                Cash Card Amount :
                <span class="text-danger"
                  >-{{ currFormat(CashCardAmount) }}
                  {{ currencyData.curr_code }}</span
                >
                <br />
              </span>
              <span class="totalAmount">
                Total Amount Paid:
                {{
                  parseFloat(
                    totalAmount -
                      offerPrice -
                      getloyaltyAmount -
                      parseFloat(CashCardAmount)
                  ).toFixed(2)
                }}
                {{ currencyData.curr_code }}
              </span>
            </h6>
            <!-- Total Amount : {{ calculateTicketPrice(bookingDetails.sb_total_amount) }} {{ getcurrency }} -->
          </div>
        </div>
      </div>
      <p class="text-center">Reward Points Earned: {{ getEarnPoints }}</p>

      <add-customer-details modalId="addcustmodal1" />
      <ChangeUserLocationPopUp :onCancelUserLocationPopUp="callClose" />
      <pos-email-booking-details-dialog
        dialogId="email_booking_details_dialog_2"
      />
      <AddComment />

      <!-- <p class="text-center">
        <button
          class="btn-blue-lg bg-blue text-white ml-1 text-center"
          v-on:click="$bvModal.show('addcustmodal1')"
        >
          {{ $t("add") }}  {{ $t("customer") }} {{ $tc("details", 1) }}
        </button>
      </p> -->

      <div ref="printthis" id="PrintTicketIDIDID" class="d-none ticket-wrapper">
        <header class="ticket-header">BRIJ</header>
        <section class="ticket-section">
          <small class="custom-block">{{ bookingDetails.cine_name }}</small>
          <small class="custom-block"
            >VAT REG : {{ bookingDetails.cine_registration_number }}</small
          >
          <small class="custom-block custom-mb-2"
            >Tel : {{ bookingDetails.cine_phone }}</small
          >
          <div class="custom-mb-2">
            <strong class="custom-pd">{{ bookingDetails.movie_title }}</strong>
          </div>
          <div class="custom-d-flex custom-flex-wrap">
            <div class="custom-w-50 custom-mb-2">
              <div>Show Date</div>
              <strong>{{ bookingDetails.show_date }}</strong>
            </div>
            <div class="custom-w-50 custom-mb-2">
              <div>Show Time</div>
              <!-- <strong>{{bookingDetails.ss_start_show_time}}</strong> -->
              <strong>{{ bookingDetails.og_show_time | format12hours }}</strong>
            </div>
            <div class="custom-w-50 custom-mb-2">
              <div>Screen No</div>
              <strong>{{ bookingDetails.screen_name }}</strong>
            </div>
            <div class="custom-w-50 custom-mb-2">
              <div>Seat</div>
              <strong
                v-for="(bookingSeats, bookingKey) in bookingDetails.seats"
                :key="bookingKey"
                >{{ bookingSeats }}</strong
              >
            </div>
          </div>

          <div class="center-box">
            <!-- <div>Rate : {{bookingDetails.sb_total_amount}}</div> -->
            <!-- <div>IHC : 2/</div> -->
            <div>INR {{ bookingDetails.sb_total_amount }}</div>
          </div>

          <div>BRIJ</div>
          <div>
            <img :src="bookingDetails.sb_qr_code" alt />
          </div>
        </section>
      </div>

      <div class="pickup-tickets-options">
        <div class="row mx-auto">
          <!-- <div class="col-lg-4">
            <div class="pos-qrcode-wrapper">
              <img :src="bookingDetails.sb_qr_code" class="img-fluid" alt />
            </div>
            <p
              class="text-center"
            >Enter cinema using M-Ticket & QR Code Provided on your Booking Confirmation SMS</p>
          </div>-->
          <!-- <div class="col-lg-4 border-left-dashed border-right-dashed h-100"> -->

          <div class="col-lg-6 border-right-dashed h-100">
            <div
              class="pos-mobile-number"
              :class="!showSendSmsSection ? 'disbled-section' : ''"
            >
              <div>
                <div class="row">
                  <div class="col-4 mb-4">
                    <!--variant="dropdown-curve bg-theme-light"-->
                    <!--:text="getCustMobCode"-->
                    <b-dropdown
                      variant="dropdown-curve"
                      class="w-100 text-center mr-3"
                      :text="getCustMobCode ? getCustMobCode : 'Code'"
                    >
                      <div class="px-2 pb-2">
                        <input
                          required
                          autofocus
                          type="search"
                          placeholder="Search Code"
                          v-on:keyup="onSearchCode($event.target.value)"
                          v-on:keydown="onSearchCode($event.target.value)"
                          v-on:search="onSearchCode($event.target.value)"
                          v-model="searchCode"
                          class="form-control form-control-sm"
                          :disabled="!showSendSmsSection"
                        />
                      </div>
                      <b-dropdown-item
                        href="#"
                        v-for="(countrycode, countryIndex) in Countries"
                        :key="countryIndex"
                        v-on:click="onSelectHandler('countrycode', countrycode)"
                        v-if="countrycode.country_mob_code != null"
                        >{{ countrycode.country_mob_code }}</b-dropdown-item
                      >
                    </b-dropdown>
                  </div>
                  <div class="col-8 mb-4 pl-0">
                    <input
                      type="number"
                      v-model="input_number"
                      placeholder="Mobile Number"
                      class="mobile-number"
                      :disabled="!showSendSmsSection"
                      v-on:keydown="
                        (e) => {
                          if (!/[0-9]/.test(e.key) && e.keyCode !== 8) {
                            e.preventDefault();
                          }
                        }
                      "
                    />
                  </div>

                  <!-- <div> -->
                  <!--class="col-6 mb-4"-->
                  <div v-if="isSearch" class="col-12">
                    <input
                      type="email"
                      v-model="email_address"
                      placeholder="Email Address"
                    />
                  </div>
                  <!--class="col-6 mb-4"-->
                  <div v-if="isSearch" class="col-6">
                    <input
                      type="text"
                      v-model="first_name"
                      placeholder="First Name"
                    />
                  </div>
                  <!--class="col-6 mb-4"-->
                  <div v-if="isSearch" class="col-6">
                    <input
                      type="text"
                      v-model="last_name"
                      placeholder="Last name"
                    />
                  </div>
                  <!-- </div> -->

                  <div class="col-11 mx-auto">
                    <div class="row">
                      <!-- <div class="col-4 mb-2" v-for="(loop , mobile) in 12" :key="mobile">
                      <button>{{mobile}}</button>-->

                      <div
                        class="col-4 mb-2"
                        v-for="(value, index) in phone_value"
                        :key="index"
                      >
                        <button
                          v-if="index == phone_value.length - 1"
                          v-on:click="onSliceNUmber()"
                          class="number"
                          :disabled="!showSendSmsSection"
                        >
                          {{ value.name }}
                        </button>
                        <button
                          v-else-if="value.name != ''"
                          v-on:click="onClicknumber(index)"
                          class="number"
                          :disabled="!showSendSmsSection"
                        >
                          {{ value.name }}
                        </button>
                        <button
                          v-else
                          @click.prevent.stop="clearInput"
                          class="number"
                          :disabled="!showSendSmsSection"
                        >
                          C
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="text-center">
              <p v-if="showSendSmsSection">
                We will be sending you the movie ticket booking details on this
                mobile number.
              </p>
              <!-- <button
                v-on:click="onClickDelete()"
                class="btn-outline-blue-lg bg-transparent text-dark mr-1"
              >Delete</button>-->
              <button
                v-on:click="onSendSMS()"
                :disabled="!showSendSmsSection"
                class="btn-blue-lg bg-blue text-white ml-1"
                :class="!showSendSmsSection ? 'disbled-section' : ''"
              >
                Send SMS
              </button>
              <button
                class="btn-blue-lg bg-blue text-white ml-1 text-center"
                v-on:click="$bvModal.show('addcustmodal1')"
              >
                {{ $t("add") }} {{ $t("customer") }} {{ $tc("details", 1) }}
              </button>
              <button
                class="btn-outline-blue text-black m-2 text-center action-button-insets"
                @click="$bvModal.show('email_booking_details_dialog_2')"
              >
                Email Details
              </button>
              <button
                class="btn-outline-blue text-black m-2 text-center action-button-insets"
                @click="$bvModal.show('addCommentModal')"
              >
                Comment
              </button>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="pickup-icon-wrapper">
              <img
                src="@/assets/img/icons/box-office.svg"
                class="img-fluid"
                alt
              />
            </div>

            <div class="text-center">
              <p class="pb-4">Enter cinema with physical movie ticket</p>
              <button
                v-if="isReprint"
                @click="goToRoute(true)"
                class="btn-outline-blue-lg bg-transparent text-dark mr-1"
              >
                Reprint
              </button>
              <button
                v-if="!isReprint"
                @click="goToRoute()"
                class="btn-blue-lg bg-blue text-white ml-1"
              >
                Print
              </button>
              <button
                v-if="ShowPrintReceipt == 'Y'"
                @click="PrintReceipt()"
                class="btn-blue-lg bg-blue text-white ml-1"
              >
                Print Receipt
              </button>
              <button
                v-if="
                  printTimCardHolderReceipt &&
                    USE_TIM_INTEGRATION == 'Y' &&
                    PRINT_TIM_CARD_RECEIPT_POS == 'Y'
                "
                @click="printCreditCardReceiptTim()"
                class="btn-blue-lg bg-blue text-white ml-1"
              >
                Card Receipt
              </button>
            </div>
          </div>
        </div>
      </div>

      <BO-sales-receipt ref="SalesReceipt"></BO-sales-receipt>

      <Bo-Fnb-sales-receipt
        ref="boxofficefnb_SalesReceipt"
      ></Bo-Fnb-sales-receipt>

      <Ticket-Product-sales-receipt
        ref="ticketsprodcuts_SalesReceipt"
      ></Ticket-Product-sales-receipt>
    </div>
    <div
      id="cardReceiptTim"
      ref="cardReceiptTim"
      style="width: 100%; text-align: center;"
      class="d-none"
    >
      <pre style="white-space: pre-wrap" v-text="TIM_CARDHOLDER_RECEIPT"></pre>
    </div>
    <div id="v-idle" style="display: none">
      <!-- :duration in seconds-->
      <v-idle
        @idle="onIdleCheckout"
        :events="['mousemove', 'keypress', 'ontouchstart', 'onclick']"
        :loop="true"
        :duration="pos_final_page_standBy_time * 60"
      />
    </div>
    <div ref="onPrint" class="d-none">
      <div v-html="empireTicketEjs"></div>
    </div>
    <ManagerAuthLogin
      :moduleName="'ticket_print'"
      :onCheckAuth="onCheckAuthentication"
      :refId="'authManager_ticket_print'"
    />
  </div>
</template>

<script>
  import Printd from "printd";
  import moment from "moment";
  import MasterService from "@/services/MasterService";
  import OCTemplate from "@/components/Pages/PosBookingContainer/PrintTicketTemplates/One_Copy_Template";
  import ThreeCTemplate from "@/components/Pages/PosBookingContainer/PrintTicketTemplates/3_Copies_Template";
  import DefaultTemplate from "@/components/Pages/PosBookingContainer/PrintTicketTemplates/Default_Template";
  import ArabicTemplate from "@/components/Pages/PosBookingContainer/PrintTicketTemplates/Arabic_Template";
  import AddCustomerDetailsPopup from "@/components/Partials/AddCustomerDetailsPopup";
  import ChangeUserLocationPopUp from "@/components/Partials/ChangeUserLocationPopUp";
  import AddComment from "@/components/Partials/AddTransactionComment";
  import posEmailBookingDetailsFormDialog from "@/components/Partials/posEmailBookingDetailsFormDialog";

  import SReceipt from "@/components/Pages/PosBookingContainer/ReceiptTemplates/sales_receipts";
  import BOFnbSReceipt from "@/components/Pages/PosBookingContainer/ReceiptTemplates/bo&fnb_sales_receipt";
  import TPSReceipt from "@/components/Pages/PosBookingContainer/ReceiptTemplates/Tickets_Products_sales_receipt";
  import { BASEURL } from "@/config/index";
  import { authenticationService } from "@/services/AuthenticationService";

  import { EventBus } from "@/main";
  import { mapState, mapGetters, mapActions } from "vuex";
  import { Role, CLIENT_NAME, CLIENT_NAMES_OBJ } from "@/helper/Role";
  import ManagerAuthLogin from "@/components/Partials/AuthManagerLoginPopup";
  import PosService from "../../../services/PosService";

  export default {
    components: {
      "onecopy-template": OCTemplate,
      "threecopy-template": ThreeCTemplate,
      "default-template": DefaultTemplate,
      "arabic-template": ArabicTemplate,
      "BO-sales-receipt": SReceipt,
      "Bo-Fnb-sales-receipt": BOFnbSReceipt,
      "Ticket-Product-sales-receipt": TPSReceipt,
      "add-customer-details": AddCustomerDetailsPopup,
      "pos-email-booking-details-dialog": posEmailBookingDetailsFormDialog,
      AddComment,
      ChangeUserLocationPopUp,
      ManagerAuthLogin,
    },
    props: {
      onClickHandler: {
        type: Function,
      },
      onBackHandler: { type: Function },
      onClickCloseButton: { type: Function },
    },
    data() {
      return {
        transactionIds: [],
        noAuth: false,
        item: {
          seatPrice: 0,
          seatType: "",
          seatName: "",
        },
        SelectedCountryCode: "",
        printIndex: 0,
        isReprint: false,
        phone_value: [
          { name: "1" },
          { name: "2" },
          { name: "3" },
          { name: "4" },
          { name: "5" },
          { name: "6" },
          { name: "7" },
          { name: "8" },
          { name: "9" },
          { name: "" },
          { name: "0" },
          { name: "<-" },
        ],
        // input_number: "",
        email_address: "",
        first_name: "",
        last_name: "",
        cust_id: null,
        isSearch: false,
        isSetData: false,
        TemplateList: [],
        Countries: [],
        CodeListCopy: [],
        currencyData: "",
        searchCode: "",
        cinemaIdEmpire: "",
        empireTicketEjs: "",
        CountriesMethod: {
          GET: "/admin/",
          tableName: "ms_countries",
          urlKey: "countries",
        },
      };
    },
    watch: {
      "$store.getters.getIsOldCustomer": function(newVal, oldVal) {
        if (newVal) {
          this.email_address = this.$store.getters.getCustomerDetails.cust_email;
          this.first_name = this.$store.getters.getCustomerDetails.first_name;
          this.last_name = this.$store.getters.getCustomerDetails.last_name;
          this.cust_id = this.$store.getters.getCustomerDetails.cust_id;
        }
      },
      "$store.getters.BOOKING_DETAILS": function(newVal) {
        if (newVal) {
          this.EmitBookingDetails(newVal);
        }
      },
    },
    computed: {
      printTimCardHolderReceipt() {
        console.log(
          "this.$store.getters.TIM_CARDHOLDER_RECEIPT",
          this.$store.getters.TIM_CARDHOLDER_RECEIPT
        );
        return this.$store.getters.TIM_CARDHOLDER_RECEIPT;
      },
      ShowPrintReceipt() {
        return this.$store.getters.showPrintReceiptBtn;
      },
      pos_final_page_standBy_time() {
        console.log(
          "parseInt(this.$store.getters.POS_FINAL_PAGE_STANDBY_TIME)",
          parseInt(this.$store.getters.POS_FINAL_PAGE_STANDBY_TIME)
        );
        return parseInt(this.$store.getters.POS_FINAL_PAGE_STANDBY_TIME);
      },
      showSendSmsSection() {
        if (
          this.$store.getters.ShowSendSMSSection &&
          this.$store.getters.ShowSendSMSSection == "N"
        ) {
          return false;
        } else {
          return true;
        }
      },
      getCustMobCode() {
        return this.$store.getters.getCustMobCode;
      },
      // TemplateList() {
      //   return this.$store.getters.getTicketTemplates;
      // },
      CashCardAmount() {
        return this.$store.getters.isCashCardDetail.hasOwnProperty("cardAmount")
          ? this.$store.getters.isCashCardDetail.cardAmount
          : 0;
      },
      SeatGroupType() {
        let groupTypeText = "";
        let tempArray = [];
        console.log(
          "this.$store.getters.seatGroupByType",
          this.$store.getters.seatGroupByType
        );
        if (this.$store.getters.isGroupExist) {
          this.$store.getters.seatGroupByType.map((x, index) => {
            if (x.count > 0) {
              let seatType = x.count + " " + x.tt_name;
              tempArray.push(seatType);
            }
            // if (
            //   index == this.$store.getters.seatGroupByType.length - 1 &&
            //   x.count > 0
            // ) {
            //   groupTypeText += `${x.count} ${x.tt_name} `;
            // } else if (x.count > 0) {
            //   groupTypeText += `${x.count} ${x.tt_name}, `;
            // }
          });
        }
        groupTypeText = tempArray.join(", ");
        console.log("groupTypeText", groupTypeText);

        return groupTypeText;
      },
      input_number: {
        get() {
          return this.$store.getters.customer_mobile_number;
        },
        set(value) {
          this.$store.dispatch("updateCustomerMobileNumber", value);
        },
      },
      getIsOldCustomer() {
        return this.$store.getters.getIsOldCustomer;
      },
      DirectPrint() {
        return this.$store.getters.DirectPrint;
      },
      getCustomerDetails() {
        return this.$store.getters.getCustomerDetails;
      },
      GET_MERIT_GIFT_CARD_DETAILS() {
        return this.$store.getters.GET_MERIT_GIFT_CARD_DETAILS;
      },
      MeritCardAmount() {
        let amount = 0;
        let gc_details = this.$store.getters.GET_MERIT_GIFT_CARD_DETAILS;
        if (gc_details) {
          amount = +parseFloat(gc_details["amount"]).toFixed(2);
        }
        return amount;
      },
       _getloyaltyAmount() {
      let merit_amount = 0;
      let gc_details = this.$store.getters.GET_MERIT_GIFT_CARD_DETAILS;
      if(gc_details) {
        merit_amount = +parseFloat(gc_details['amount']).toFixed(2)
      }
      if(merit_amount > 0) {
        return merit_amount;
      } else {
        return this.$store.getters.getloyaltyAmount;
      }
    },
    getloyaltyAmount() {
      return this.$store.getters.getloyaltyAmount;
    },
      getEarnPoints() {
        return this.$store.getters.getEarnPoints;
      },
      bookingDetails() {
        return this.$store.getters.BOOKING_DETAILS;
      },
      offerFor() {
        return this.$store.getters.getOfferFor;
      },
      getSelectedOffer() {
        return this.$store.getters.getSelectedOffer;
      },
      offerPrice() {
        return this.getOfferPrice
          ? +parseFloat(this.getOfferPrice).toFixed(2)
          : 0;
      },
      totalAmount() {
        return +parseFloat(this.$store.getters.TOTAL_AMOUNT).toFixed(2);
      },
      netAmount() {
        return this.$store.getters.NET_AMOUNT;
      },
      AdditionalCharges() {
        return this.$store.getters.ADDITIONAL_CHARGES;
      },
      getcurrency() {
        return this.$store.getters.GET_CURRENCY;
      },
      showBookingId() {
        return this.$store.getters.SHOW_BOOKING_ID;
      },
      getSeats() {
        let key = "seatType";
        if (
          this.$store.getters.BOOKING_DETAILS &&
          this.$store.getters.BOOKING_DETAILS.seats_types &&
          this.$store.getters.BOOKING_DETAILS.seats_types.length > 0
        ) {
          return this.$store.getters.BOOKING_DETAILS.seats_types.reduce(
            function(rv, x) {
              (rv[x[key]] = rv[x[key]] || []).push(x);
              return rv;
            },
            {}
          );
        }
        // };
        // return groupBy;
        // (groupBy(['one', 'two', 'three'], 'length'))
      },
      getSelectedArray() {
        let array = [];
        if (
          this.bookingDetails &&
          this.bookingDetails["seats_types"] &&
          this.bookingDetails["seats_types"].length > 0
        ) {
          this.bookingDetails.seats_types.map((x) => {
            x.seats.map((y) => {
              array.push({
                seatName: y,
                seatType: x.seat_type,
              });
            });
          });
        }
        return array;
      },
      // ...mapActions(["resetTransactionIds"]),
      ...mapGetters([
        "getOfferPrice",
        "getSelectedOffer",
        "getOfferFor",
        "RateCardAddonsChargesList",
        "RateCardAddonsChargesFinalAmount",
        "RateCardAddonsOnTicketChargesFinalAmount",
        "RateCardAddonsOnTicketChargesList",
        "RateCardAddonsOnTicketChargeTypes",
        "MANAGER_AUTH_FOR_REPRINT",
        "TIM_CARDHOLDER_RECEIPT",
        "USE_TIM_INTEGRATION",
        "PRINT_TIM_CARD_RECEIPT_POS",
        "TRANSACTION_IDARR",
      ]),
    },
    beforeMount() {
      const { cinema_id } = this.secureStore.get("USINFO");
      this.cinemaIdEmpire = this.secureStore.get("USINFO").cinema_id;
      this.getCinemaTicketTemplate(cinema_id);
      this.getCurrencyCode();
      console.log(
        this.$store.getters.TRANSACTION_IDARR,
        "this.$store.getters.TRANSACTION_IDARR"
      );
      this.transactionIds = this.$store.getters.TRANSACTION_IDARR.split(",");
      this.SelectedCountryCode = this.getCustMobCode;
    },
    mounted() {
      var count = 0;
      var setIntervalTimeout = setInterval((x) => {
        console.log("fsdfsdfsd", count++);
        if (this.bookingDetails) {
          clearInterval(setIntervalTimeout);
          console.log(
            "this.bookingDetails test for new empire",
            this.bookingDetails
          );
          this.EmitBookingDetails(this.bookingDetails);
          //new empire ticket
          // this.getTransactionIds();
        }
      }, 1000);
      this.getCountriesList();
      // this.EmitBookingDetails();
      // this.$store.dispatch("ADD_TRANSCATION_DETAILS", {
      //   schedule_show_id: this.$store.getters.SCHEDULE_SHOW_ID,
      //   selected_seats: this.$store.getters.SELECTED_SEATS,
      //   show_details: this.$store.getters.SHOW_DETAILS
      // });
    },
    methods: {
      getTransactionIds() {
        let payload = {
          bookingCode: this.bookingDetails.sb_booking_code,
        };
        PosService.PosBookingDetailsEmpire(payload)
          .then((response) => {
            const { data } = response;
            this.transactionIds = data.Records.t_id.split(",");
            // this.printNewEmpireTicket();
            console.log("this.transactionIds", this.transactionIds);
          })
          .catch((err) => {
            console.log(err);
          });
      },
      printNewEmpireTicket() {
        console.log("inseide fn");
        if (this.transactionIds && this.transactionIds.length > 0) {
          // for (var t_id of this.transactionIds) {
          //  }
          this.transactionIds.map((x) => {
            console.log("inside for");
            PosService.GetEmpireTicketEjs(x, this.cinemaIdEmpire, false)
              .then((response) => {
                const { data } = response;
                this.empireTicketEjs = data;

                var userAgent = navigator.userAgent.toLowerCase();

                if (userAgent.indexOf(" electron/") > -1) {
                  try {
                    if (this.$socket) {
                      this.$socket.emit("on_print_ticket", {
                        t_id: x,
                        cinema_id: this.cinemaIdEmpire,
                        baseurl: BASEURL,
                        ttype: "empire-new-ticket",
                        isReprint: false,
                      });
                      // this.$socket.emit("on_print_ticket", {
                      //   t_id: x,
                      //   cinema_id: this.cinemaIdEmpire,
                      //   baseurl: BASEURL,
                      //   ttype: "security-ticket-empire",
                      //   isReprint: false
                      // });
                    }
                  } catch (err) {
                    console.log("Error:", err);
                  }
                } else {
                  this.$nextTick(() => {
                    // loader.hide();
                    const p = new Printd();
                    if (this.$refs.onPrint && this.empireTicketEjs != null) {
                      p.print(this.$refs.onPrint, []);
                    }
                  });
                }
              })
              .then(() => {
                this.$socket.emit("on_print_ticket", {
                  t_id: x,
                  cinema_id: this.cinemaIdEmpire,
                  baseurl: BASEURL,
                  ttype: "security-ticket-empire",
                  isReprint: false,
                });
              })
              .catch((err) => {
                console.log(err);
              });

            ///security-part
          });
        }
        console.log();
      },
      rateCardAddonsChargeTypeToAdd(ct_id) {
        let result = 0;
        if (!ct_id) return result;

        result = this.RateCardAddonsOnTicketChargeTypes.filter(
          (c) => c.ct_id == ct_id
        )
          .map((c) => c.final_value || 0)
          .reduce((prev, curr) => prev + curr, 0);
        return result || 0;
      },
      rateCardAddonsNetAdd() {
        let result = 0;
        result = this.RateCardAddonsOnTicketChargeTypes.map(
          (c) => c.net_value || 0
        ).reduce((prev, curr) => prev + curr, 0);

        return result;
      },
      printCreditCardReceiptTim() {
        if (this.TIM_CARDHOLDER_RECEIPT) {
          this.$store.dispatch("onSetAndSendLog", {
            action: `Selected TIM Cardholder option`,
            page_name: "POS booking",
            api_name: window.location.hash,
          });
          const { cinema_id } = this.secureStore.get("USINFO");
          var userAgent = navigator.userAgent.toLowerCase();
          if (userAgent.indexOf(" electron/") > -1) {
            try {
              if (this.$socket) {
                this.$socket.emit("on_print_ticket", {
                  ttype: "tim_card_holder_receipt",
                  htmlData: document.getElementById("cardReceiptTim").outerHTML,
                });
              }
            } catch (err) {}
          } else {
            let loader = this.$loading.show();
            this.EjsData = this.TIM_CARDHOLDER_RECEIPT;
            this.$nextTick(() => {
              loader.hide();
              const p = new Printd();
              if (this.$refs.cardReceiptTim) {
                p.print(this.$refs.cardReceiptTim, []);
              }
            });
          }
        } else {
          this.$toasted.show("Card holder receipt not found");
        }
      },
      onIdleCheckout() {
        console.log("Idle checkout call close");
        this.callClose();
      },
      EmitBookingDetails(bookingDetails) {
        console.log("Calling EmitBookingDetails");
        bookingDetails["SeatGroupType"] = this.SeatGroupType;
        bookingDetails["totalAmount"] = this.totalAmount;
        bookingDetails["curr_code"] = this.currencyData.curr_code;
        bookingDetails["getStoreLoyalityAmount"] = this.getloyaltyAmount;
        bookingDetails["offerPrice"] = this.offerPrice;
        bookingDetails["getSelectedOffer"] = this.getSelectedOffer;
        bookingDetails["CashCardAmount"] = this.CashCardAmount;
        bookingDetails["AdditionalCharges"] = this.AdditionalCharges;
        bookingDetails["netAmount"] = this.netAmount;
        try {
          if (this.$socket) {
            this.$socket.emit("set_final_ticket", bookingDetails);
          }
        } catch (err) {}
      },
      getCurrencyCode: function() {
        let payload = {
          tableName: "ms_currencies",
          curr_is_active: "Y",
          curr_id:
            this.secureStore.get("BRGLOPCU") &&
            this.secureStore.get("BRGLOPCU").go_value,
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.currencyData = data.Records[0];
            } else {
              // Show Error Message:
            }
          })
          .catch((error) => {
            // Catch Error:
            console.log("Catch Error:", error);
          });
      },
      onSearchCode() {
        if (this.searchCode && this.searchCode.length > 0) {
          this.Countries = this.CodeListCopy.filter((x) => {
            if (
              x.country_mob_code &&
              x.country_mob_code
                .toLowerCase()
                .includes(this.searchCode.toLowerCase())
            ) {
              return x;
            }
          });
        } else {
          this.Countries = this.CodeListCopy;
        }
      },
      getCountriesList: function() {
        this.Countries = [];
        let body = this.getRequestBody("GET", undefined, this.CountriesMethod);
        MasterService.GlobalRequest(body)
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.Countries = data.Records;
              this.CodeListCopy = data.Records;
            } else {
              console.log("show error :", data.message);
            }
          })
          .catch((error) => {
            console.log("show error :", error);
          });
      },
      onSelectHandler: function(type, value) {
        this.SelectedCountryCode = value.country_mob_code;
        this.$store.dispatch("updateCountryMobCode", value.country_mob_code);
      },
      calculateTicketPrice(value) {
        return value
          ? parseFloat(parseFloat(value) - parseFloat(this.offerPrice)).toFixed(
              2
            )
          : 0;
      },
      getCinemaTicketTemplate: function(cinema_id) {
        let body = {
          cine_id: cinema_id,
        };
        MasterService.TicketTemplateByCinemaID(body).then((response) => {
          const { data } = response;

          if (data.status) {
            if (data.Records && data.Records.length > 0) {
              this.TemplateList = data.Records;
              if (this.DirectPrint == "Y" && !this.isReprint) {
                console.log("Direct Print is calling");
                this.goToRoute();
              }
            }
          }
        });
      },
      checkDifferentUserLocation() {
        let default_token = authenticationService.get("DFLT_USINFO");
        let logged_token = authenticationService.get("USINFO");
        if (
          default_token &&
          logged_token &&
          default_token.hasOwnProperty("user_id") &&
          logged_token.hasOwnProperty("user_id")
        ) {
          if (default_token.user_id == logged_token.user_id) {
            return true;
          } else {
            this.$bvModal.show("userLocationPopup");
            return false;
          }
        } else {
          return true;
        }
      },
      callClose: function(check = true) {
        // this.onClickHandler("PosFinalTicket");
        // this.$nextTick(() => {
        //   this.onBackHandler();
        // });
        let checkCount = 0;

        if (check) {
          if (!this.checkDifferentUserLocation()) {
            checkCount++;
          } else {
            checkCount = 0;
          }
        }

        if (checkCount == 0) {
          try {
            if (this.$socket) {
              this.$socket.emit("home_page");
            }
          } catch (err) {}
          this.onClickCloseButton();
          this.onClickHandler("Refresh");
        }
        this.$store.commit("RESET_TRANSACTION_ID");
      },
      clearInput: function() {
        this.input_number = "";
      },
      onClicknumber: function(index) {
        this.input_number += this.phone_value[index].name;
      },
      onClickDelete: function() {
        this.$store.dispatch("clearAllInput");
        // this.input_number = "";
      },
      onSliceNUmber: function() {
        this.$store.dispatch("sliceNumber");
      },
      onSendSMS() {
        console.log("this.input_number", this.input_number);
        console.log("this.SelectedCountryCode", this.SelectedCountryCode);
        if (
          this.input_number.length > 0 &&
          this.SelectedCountryCode.length > 0
        ) {
          this.$store.dispatch("sendSms", { source: "ticket" });
          // this.$store.dispatch("updateCustomerBookings", {
          //   first_name: this.first_name,
          //   last_name: this.last_name,
          //   mobile_number: this.input_number,
          //   cust_email: this.email_address,
          //   cust_id: this.cust_id
          // });
          // this.first_name = "";
          // this.last_name = "";
          // this.input_number = "";
          // this.email_address = "";
          // this.isSearch = false;
        } else {
          this.$toasted.show(
            "Please enter mobile number and select country code"
          );
        }
      },
      onSearch: function() {
        if (this.input_number.length > 0) {
          // this.$toasted.show("Ticket Booking Details Sent Successfuly. ");
          this.$store.dispatch("setUserDeatils", {
            sb_mobile_number: this.input_number,
            sb_booking_code: this.bookingDetails.sb_booking_code,
            cust_id: this.$store.getters.getCustomerDetails.cust_id || 0,
          });
          this.isSearch = true;
          this.$store.dispatch("onSetAndSendLog", {
            action: `SMS option selected for ticket at number : ${this.input_number}`,
            page_name: "POS booking",
            api_name: window.location.hash,
          });
        } else {
          this.$toasted.show("Please enter Mobile Number.");
        }
        // SendSmS Service
      },
      getSelectedSeatsAndClass: function() {
        let str = "";
        // this.bookingDetails.seats_types.map((bookingSeats, bookingKey) => {
        //   str += ` <p
        //             style="'font-size': '14px', 'font-weight': '600', 'padding': '5px 0px','margin':'0', 'border-bottom': ${
        //               bookingKey === this.bookingDetails.seats_types.length - 1
        //                 ? 0
        //                 : "1px solid #d3d3d3"
        //             }"
        //           >${bookingSeats.seat_type}: ${bookingSeats.seats.join(", ") ||
        //     ""}</p>`;
        // });

        str += ` <p
                  style="'font-size': '14px', 'font-weight': '600', 'padding': '5px 0px','margin':'0', 'border-bottom': 0"
                  >${this.getSelectedArray[this.printIndex].seatType}: ${
          this.getSelectedArray[this.printIndex].seatName
        }</p>`;
        return str;
      },
      getCinemaCharges: function() {
        let str = "";

        this.AdditionalCharges.map((Charge) => {
          str += `<p style="font-size:12px;margin:0 0 5px 0;"
                    >${Charge.ct_name}&nbsp;${
            Charge.sp_value ? Charge.sp_value.toFixed() : ""
          }</p>`;
        });

        return str;
      },
      onCheckAuthentication(response) {
        const { valid, name } = response;
        if (valid) {
          if (name == "ticket_print") {
            this.noAuth = true;
            this.$bvModal.hide("authManager_ticket_print");
            this.goToRoute();
          }
        }
      },
      goToRoute: function(isReprint = false) {
        let checkClient = this.authorizeClient(
          CLIENT_NAMES_OBJ.empire_iraq_lebanon
        );
        if (isReprint && !this.noAuth && this.MANAGER_AUTH_FOR_REPRINT == "Y") {
          this.$bvModal.show("authManager_ticket_print");
        } else {
          this.$store.dispatch("onSetAndSendLog", {
            action: this.isReprint
              ? `Selected Reprint option .`
              : `Selected Print option .`,
            page_name: "POS booking",
            api_name: window.location.hash,
          });
          const { cinema_id } = this.secureStore.get("USINFO");
          this.$store.commit("SET_REPRINT", this.isReprint);
          var userAgent = navigator.userAgent.toLowerCase();
          console.log(this.TemplateList, "templateList");
          if (userAgent.indexOf(" electron/") > -1) {
            try {
              if (this.$socket) {
                let addOnsArr = this.bookingDetails.final_addon_gross_charges.filter(
                  (add_on) => {
                    return add_on.is_additional_price_on_ticket === "N";
                  }
                );
                let arabic_company_name = JSON.parse(
                  this.bookingDetails.translation_data
                ).filter((lang) => {
                  return lang.langaugeId == 3;
                })[0].company_name;
                // console.log('data',this.$store.getters)
                //console.log("showBookingId", this.bookingDetails.sb_id)
                if (String(this.TemplateList[0].t_name) != "Template-12") {
                  this.$socket.emit("on_print_ticket", {
                    showBookingId: this.bookingDetails.sb_id,
                    cinema_id,
                    baseurl: BASEURL,
                    isReprint: this.isReprint,
                  });
                  if (checkClient) {
                    // setTimeout(z => {
                    let overallPrice = 0;
                    addOnsArr.map((z, index) => {
                      overallPrice += z.final_price;
                      setTimeout(() => {
                        this.$socket.emit("on_print_ticket", {
                          addOns: JSON.stringify(z),
                          bookingDetails: JSON.stringify({
                            template_id: this.TemplateList[0].template_id,
                            pos_user_name: this.bookingDetails.pos_user_name,
                            translationData: arabic_company_name,
                            cine_name: this.bookingDetails.cine_name,
                            cine_address: this.bookingDetails.cine_address,
                            company_name: this.bookingDetails.company_name,
                            vat_number: this.bookingDetails.vat_number,
                            sb_id: this.bookingDetails.sb_id,
                            sb_booking_code: this.bookingDetails
                              .sb_booking_code,
                            og_show_date: this.bookingDetails.og_show_date,
                            og_show_time: this.bookingDetails.og_show_time,
                            sb_booking_date: this.bookingDetails
                              .sb_booking_date_time,
                            sb_booking_time: this.bookingDetails
                              .sb_booking_date_time,
                          }),
                          ttype: "addon-ticket",
                          isReprint: this.isReprint,
                          baseurl: BASEURL,
                        });
                      }, 2000);
                      // index * setTimeoutvalue);
                    });
                    // console.log("AJitttttt");

                    setTimeout(() => {
                      this.$socket.emit("on_print_ticket", {
                        showBookingId: this.bookingDetails.sb_id,
                        cinema_id,
                        overallPrice,
                        baseurl: BASEURL,
                        ttype: "security-ticket",
                        addOnsArr: JSON.stringify(addOnsArr),
                        isReprint: this.isReprint,
                      });
                    }, 2000);

                    // setTimeout(() => {
                    //   this.$socket.emit("on_print_ticket", {
                    //     b_code: this.bookingDetails.sb_booking_code,
                    //     cinema_id: this.cinemaIdEmpire,
                    //     baseurl: BASEURL,
                    //     ttype: "security-ticket-empire",
                    //     addOnsArr: JSON.stringify(addOnsArr),
                    //     isReprint: "N"
                    //   });
                    // }, 2500);
                  }
                } else if (this.TemplateList[0].t_name == "Template-12") {
                  console.log("in else condition", this.transactionIds);
                  let addOnsArr = this.bookingDetails.final_addon_gross_charges.filter(
                    (add_on) => {
                      return add_on.is_additional_price_on_ticket === "N";
                    }
                  );
                  console.log({ addOnsArr });
                  let setTimeoutvalue = 2000;
                  let arabic_company_name = JSON.parse(
                    this.bookingDetails.translation_data
                  ).filter((lang) => {
                    return lang.langaugeId == 3;
                  })[0].company_name;

                  this.transactionIds.map(async (x, index) => {
                    setTimeout(async () => {
                      await this.$socket.emit("on_print_ticket", {
                        t_id: x,
                        cinema_id: this.cinemaIdEmpire,
                        baseurl: BASEURL,
                        ttype: "empire-new-ticket",
                        isReprint: false,
                      });
                    }, index * setTimeoutvalue);
                  });

                  setTimeout(() => {
                    if (addOnsArr.length > 0) {
                      setTimeout(() => {
                        console.log(
                          "in addonsarr",
                          addOnsArr.length,
                          addOnsArr
                        );
                        addOnsArr.map(async (z, index) => {
                          setTimeout(async () => {
                            await this.$socket.emit("on_print_ticket", {
                              addOns: JSON.stringify(z),
                              bookingDetails: JSON.stringify({
                                template_id: this.TemplateList[0].template_id,
                                pos_user_name: this.bookingDetails
                                  .pos_user_name,
                                translationData: arabic_company_name,
                                cine_name: this.bookingDetails.cine_name,
                                cine_address: this.bookingDetails.cine_address,
                                company_name: this.bookingDetails.company_name,
                                vat_number: this.bookingDetails.vat_number,
                                sb_id: this.bookingDetails.sb_id,
                                sb_booking_code: this.bookingDetails
                                  .sb_booking_code,
                                og_show_date: this.bookingDetails.og_show_date,
                                og_show_time: this.bookingDetails.og_show_time,
                                sb_booking_date: this.bookingDetails
                                  .sb_booking_date_time,
                                sb_booking_time: this.bookingDetails
                                  .sb_booking_date_time,
                              }),
                              ttype: "addon-ticket",
                              isReprint: "N",
                              baseurl: BASEURL,
                            });
                          }, index * setTimeoutvalue);
                        });
                      }, 2000);
                    }
                  }, this.transactionIds.length * setTimeoutvalue);

                  setTimeout(() => {
                    setTimeout(() => {
                      this.transactionIds.map(async (y, index) => {
                        setTimeout(async () => {
                          await this.$socket.emit("on_print_ticket", {
                            t_id: y,
                            cinema_id: this.cinemaIdEmpire,
                            baseurl: BASEURL,
                            ttype: "security-ticket-empire",
                            addOnsArr: JSON.stringify(addOnsArr),
                            isReprint: "N",
                          });
                        }, index * 2000);
                      });
                    }, 3000);
                  }, this.transactionIds.length * setTimeoutvalue + addOnsArr.length * setTimeoutvalue + 2000);

                  console.log("after else condition");
                }
              }
            } catch (err) {}
          } else {
            if (this.TemplateList && this.TemplateList.length > 0) {
              console.log(this.TemplateList[0].template_id);
              const p = new Printd();
              if (this.TemplateList[0].template_id == 1) {
                EventBus.$emit("printThreeCopyTemp");
              } else if (this.TemplateList[0].template_id == 2) {
                EventBus.$emit("printOneCopyTemp");
              } else if (this.TemplateList[0].template_id == 3) {
                EventBus.$emit("printDefaultTemp");
              } else if (this.TemplateList[0].template_id == 4) {
                EventBus.$emit("printArabicTemp");
              } else if (this.TemplateList[0].t_name == "Template-12") {
                EventBus.$emit("printDefaultTempEmpire");
              } else {
                EventBus.$emit("printDefaultTemp");
              }
            } else {
              this.$toasted.show("Please select a default ticket template");
            }
          }
          this.isReprint = true;
        }
      },
      PrintReceipt: function() {
        this.$store.dispatch("onSetAndSendLog", {
          action: `Selected PrintReciept button for ticket print.`,
          page_name: "POS Final Ticket",
          api_name: window.location.hash,
        });
        // const p = new Printd();
        // p.print(this.$refs.SalesReceipt, []);
        if (this.TemplateList && this.TemplateList.length > 0) {
          if (this.TemplateList[0].receipt_temp_id == 1) {
            EventBus.$emit("printSalesReceipt");
          } else if (this.TemplateList[0].receipt_temp_id == 2) {
            EventBus.$emit("printBO&FnbReceipt");
          } else if (this.TemplateList[0].receipt_temp_id == 3) {
            EventBus.$emit("printBO&FnbReceipt");
          } else {
            EventBus.$emit("printSalesReceipt");
          }
        } else {
          this.$toasted.show("Please select a default receipt template");
        }
      },

      sss___goToRoute: async function() {
        console.log("this.getSelectedArray :", this.getSelectedArray);
        // this.isReprint = true;
        // const p = new Printd();
        // p.print(this.$refs.printnewticket, []);
        // printable: 'printJS-form', type: 'html'
        let self = this;

        let array = [{ name: "P" }, { name: "D" }, { name: "H" }];

        let rawHTML = `<div
                  ref="printnewticket"
                  id="NEWPrintTicketNewIDIDID"
                  style="transform: rotate(90deg);display: table-cell; padding-top: 35px"
                  >`;

        let Promisess = array.map((x, index) => {
          rawHTML += `<div class="print-tickets">
                      <table border="0" style="width:410px;line-height:1; border:1px solid">
                        <tr>
                          <td colspan="3" style="padding:2px 10px;">
                            <table style="width:100%">
                              <tr>
                                <td style="vertical-align:top;">
                                  <p style="font-size:18px;font-weight:600;margin:0">${
                                    x.name
                                  }</p>
                                </td>
                                <td>
                                  <p
                                  style="font-size:14px;font-weight:600;margin: 0 0 5px 0"
                                  >UMA MANDIR - SOLAPUR</p>
                                  <p
                                  style="font-size:14px;font-weight:600;margin: 0;display: flex;justify-content: space-between;"
                                  >
                                  <span>${
                                    this.bookingDetails.movie_title
                                  }</span>
                                  <span
                                  style="font-size: 12px; margin: 0px 0px 5px;letter-spacing: 0.3px;"
                                  >Transaction No: ${
                                    this.bookingDetails.sb_booking_code
                                  }</span>
                                </p>
                                <span
                                style="font-size: 14px; margin: 0px 0px 5px;"
                                >Issued on: ${this.$options.filters.fulldatemonparse(
                                  new Date()
                                )}</span>
                                </td>
                              </tr>
                            </table>
                          </td>
                        </tr>
                        <tr>
                          <td style="width:33.33%;padding: 2px 10px 2px 10px">
                            `;
          rawHTML += this.getCinemaCharges();
          rawHTML += `<p
                            style="font-size:16px;font-weight:600;margin:0;"
                            >Total: ${
                              this.bookingDetails["sb_total_amount"]
                                ? this.bookingDetails.sb_total_amount.toFixed()
                                : ""
                            }</p>
                          </td>
                          <td style="width:33.33%;padding:2px 10px 2px 10px;vertical-align:top;">
                            <p
                            style="font-size:14px;font-weight:600;margin:0 0 5px 0;"
                            >${this.$options.filters.dayonly3(
                              this.bookingDetails.og_show_date
                            )}, ${this.$options.filters.dateparse(
            this.bookingDetails.og_show_date
          )}</p>
                                <p
                                style="font-size:14px;font-weight:600;margin:0 0 10px 0;"
                                >${this.$options.filters.timeparseAmPm(
                                  this.bookingDetails.og_show_time
                                )}</p>
                                </td>
                                <td style="width:33.33%;padding:2px 10px 2px 10px;vertical-align:bottom">
                                  `;
          rawHTML += this.getSelectedSeatsAndClass();
          rawHTML += `</td>
                                </tr>
                              </table>
                            </div>`;

          if (index !== array.length - 1) {
            rawHTML += `<hr style="border:1px dashed grey; margin:3px 0px" />`;
          }
        });
        await Promise.all(Promisess);

        rawHTML += `
                        </div>`;
        // console.log("rawHTML :", rawHTML);
        printJS({
          // printable: "NEWPrintTicketNewIDIDID",
          // type: "html"
          type: "raw-html",
          printable: rawHTML,
          onPrintDialogClose: function() {
            console.log(
              "this.printIndex, this.getSelectedArray.length :",
              self.printIndex,
              self.getSelectedArray.length
            );
            if (self.printIndex !== self.getSelectedArray.length - 1) {
              self.printIndex++;
              self.goToRoute();
            } else {
              console.log("Print is Done :");
              self.printIndex = 0;
            }
          },
          // onPrintDialogClose: this.printJobComplete
        });
      },
      onError() {
        this.printIndex = 0;
      },
      printJobComplete() {
        console.log(
          "this.printIndex, this.getSelectedArray.length :",
          this.printIndex,
          this.getSelectedArray.length
        );
        if (this.printIndex !== this.getSelectedArray.length - 1) {
          this.printIndex++;
          this.goToRoute();
        } else {
          console.log("Print is Done :");
          this.printIndex = 0;
        }
      },
      __goToRoute: function() {
        this.isReprint = true;
        // this.$router.push({
        //   path: "ticket/print-ticket"
        // });
        //   this.$htmlToPaper("PrintTicketIDIDID", () => {
        //     console.log("Printing done or got cancelled!");
        //   });
        const p = new Printd();
        p.print(this.$refs.printthis, [
          `
                            @page { size: auto;  margin: 0mm; }
                            .custom-block {
                              display: block !important;
                            }
                            .custom-flex-wrap {
                              flex-wrap: wrap !important;
                            }
                            .custom-d-flex {
                              display: flex !important;
                            }
                            .custom-mb-2 {
                              margin-bottom: 0.5rem !important;
                            }
                            .custom-w-50 {
                              width: 50% !important;
                            }
                            .custom-pd {
                              padding: 4px;
                            }

                            .ticket-wrapper {
                              width: 302.36220472px;
                              height: 384px;
                              margin: 0 auto;
                              border: 1px solid #3876d2;
                              font-family: "Bw Modelica";
                            }

                            .ticket-header {
                              width: 100%;
                              text-align: center;
                              height: 26.456692913px;
                              border-bottom: 1px solid #3876d2;
                            }

                            .ticket-section {
                              text-align: center;
                              height: calc(100% - 52.913385826px);
                            }

                            .center-box {
                              width: 90%;
                              padding: 3px 8px;
                              display: flex;
                              margin: 0 auto;
                              margin-bottom: 5px;
                              justify-content: space-between;
                              border: 1px solid grey;
                            }

                            .barcode {
                              margin-left: 102.04724409px;
                              margin-right: 102.04724409px;
                              background-color: pink;
                            }

                            .ticket-footer {
                              width: 100%;
                              text-align: center;
                              border-top: 1px solid #3876d2;
                              height: 26.456692913px;
                            }`,
        ]);
      },
    },
  };
</script>

<style scoped>
  .pos-final-ticket-new {
    height: auto;
    margin: 0 auto;
    padding: 20px 15px;
    border-radius: 5px;
    margin-bottom: 15px;
    width: 975px;
    border: 1px solid #d3d3d3;
    box-shadow: 1px 1px 3px 1px #808080ad;
  }

  .pos-ticket-cutter::before,
  .pos-ticket-cutter::after {
    content: "";
    width: 25px;
    right: -13px;
    height: 25px;
    display: block;
    border-radius: 50%;
    position: absolute;
    background-color: #fff;
  }
  .pos-ticket-cutter::before {
    top: -35px;
    border-bottom: 2px solid #808080ad;
  }
  .pos-ticket-cutter::after {
    bottom: -35px;
    border-top: 2px solid #808080ad;
  }
  .pos-final-ticket-container {
    zoom: 0.8;
  }

  .action-button-insets {
    padding: 14px 16px 14px 14px;
    margin: 4px 4px 4px 4px;
  }

  .disbled-section {
    cursor: not-allowed;
    opacity: 0.4;
  }
</style>



// WEBPACK FOOTER //
// src/components/Pages/PosBookingContainer/posFinalTicket.vue